<div>
  <form [formGroup]="form">
    <div class="form-row">
      <div class="col-2">
        <mat-form-field appearance="outline" class="inputs">
          <mat-label>Nome</mat-label>
          <input
            matInput
            placeholder="Nome"
            formControlName="nome"
            maxlength="55"
            noSpecialChars
          />
          <mat-hint align="end">{{nome.value?.length}} / 55</mat-hint>
          <mat-error *ngIf="nome.hasError('required')">
            Nome completo é <strong>obrigat&oacute;rio</strong>
          </mat-error>
          <mat-error *ngIf="nome.hasError('valueOnlyNumberError')">
            Nome do titular não pode conter apenas números
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-2">
        <mat-form-field appearance="outline" class="inputs">
          <mat-label>Valor</mat-label>
          <input
            maxlength="12"
            value=""
            currencyMask
            matInput
            [options]="{
              prefix: 'R$ ',
              suffix: '',
              thousands: '.',
              decimal: ','
            }"
            placeholder="Valor"
            formControlName="valor"
          />
          <mat-error *ngIf="valor.hasError('required')">
            Valor é <strong>obrigat&oacute;rio</strong>
          </mat-error>
          <mat-error *ngIf="valor.hasError('valueZeroError')">
            O Valor não pode ser <strong>0,00</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-2">
        <mat-form-field  appearance="outline" class="inputs">
          <mat-label>Data da Dívida</mat-label>
          <input
            matInput
            formControlName="dataDivida"
            [matDatepicker]="datePicker"
            placeholder="Data da dívida"
            disableFutureDates
            readonly
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="datePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #datePicker></mat-datepicker>
          <mat-error *ngIf="dataDivida.hasError('required')">
            Data da Dívida é <strong>obrigat&oacute;ria</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-2">
        <mat-form-field appearance="outline" class="inputs">
          <mat-label>CPF/CNPJ</mat-label>
          <input
            matInput
            type='text'
            mask="000.000.000-00||00.000.000/0000-00"
            placeholder="CPF/CNPJ"
            formControlName="documento"
          />
        </mat-form-field>
      </div>
      <div class="col-2">
        <mat-form-field appearance="outline" class="inputs">
          <mat-label>N. Contrato</mat-label>
          <input
            matInput
            value=""
            placeholder="N. Contrato"
            formControlName="numeroContrato"
            maxlength="20"
          />
        </mat-form-field>
      </div>
      <div class="d-flex justify-content-center align-items-center col-auto ">
        <button
          mat-button
          type="button"
          class="btn btn-branco"
          (click)="addCredor()"
          [disabled]="!form.valid"
        >
          Adicionar
        </button>
      </div>
    </div>

  </form>

  <table mat-table class="mat-elevation-z2" [dataSource]="credores" *ngIf="credores.length > 0">
    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef> Nome </th>
      <td mat-cell *matCellDef="let credor"> {{ credor.nome }} </td>
    </ng-container>

    <ng-container matColumnDef="valor">
      <th mat-header-cell *matHeaderCellDef> Valor </th>
      <td mat-cell *matCellDef="let credor"> {{ formatValor(credor.valor) }} </td>
    </ng-container>

    <ng-container matColumnDef="dataDivida">
      <th mat-header-cell *matHeaderCellDef> Data da Dívida </th>
      <td mat-cell *matCellDef="let credor">
        {{credor.dataDivida | date:'dd/MM/yyyy'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="documento">
      <th mat-header-cell *matHeaderCellDef> Documento </th>
      <td mat-cell *matCellDef="let credor">
        {{ credor.documento ? (credor.documento | mask: isPessoaFisica(credor.documento) ? '000.000.000-00' : '00.000.000/0000-00') : "--" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="numeroContrato">
      <th mat-header-cell *matHeaderCellDef> N. Contrato </th>
      <td mat-cell *matCellDef="let credor"> {{ credor.numeroContrato || "--" }} </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef> Ações </th>
      <td mat-cell *matCellDef="let credor">
        <button mat-icon-button [matMenuTriggerFor]="menu" type="button">
          <mat-icon  class="table-icon">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="after">
          <button (click)="removeCredor(credor)" mat-menu-item>
            <mat-icon class="table-icon">close</mat-icon>
            <span>Excluir</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
